<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>字典类型管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 标题 -->
    <div class="el_div">
      <el-button
      type="primary"
      v-if="btn_permission.includes('sys:dictType:add')||btn_permission.includes('superAdmin')"
      @click='addRow()'
      >
        添加字典类型
      </el-button>
    </div>
    <!-- 字典类型列表 -->
    <el-table
    :data="listData"
    border
    max-height="400"
    :cell-style="{background:'#fff'}"
    id="emptransfer"
    >
      <el-table-column align="center" prop="id" label="ID"></el-table-column>
      <el-table-column prop="typeName" label="字典类型名称">
        <template slot-scope="scope">
          <el-input :class="[scope.row.name_show==false?'active':'off_active']" :readonly='scope.row.name_show' @focus="name_span(scope.row)" @blur="name_input(scope.row)" v-model="scope.row.typeName"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="typeCode" label="字典类型编码">
        <template slot-scope="scope">
          <el-input :class="[scope.row.code_show==false?'active':'off_active']" :readonly='scope.row.code_show' @focus="code_span(scope.row)" @blur="code_input(scope.row)" v-model="scope.row.typeCode"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="typeDesc" label="字典类型描述">
        <template slot-scope="scope">
          <el-tooltip effect="dark" :content="scope.row.typeDesc" placement="top-start">
            <el-input :class="[scope.row.des_show==false?'active':'off_active']" :readonly='scope.row.des_show' @focus="des_span(scope.row)" @blur="des_input(scope.row)" v-model="scope.row.typeDesc"></el-input>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope='scope'>
          <el-tag
          class="operate"
          effect="plain"
          v-if="btn_permission.includes('sys:dictType:del')||btn_permission.includes('superAdmin')"
          @click='deleteRow(scope.row)'
          >
            删除
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <el-pagination
    style="margin: 10px auto;"
    background
    @size-change="pageparm_size_change"
    @current-change="pageparm_current_change"
    :current-page="pageparm.currentPage"
    :page-sizes="[10, 15, 20, 25]"
    :page-size="pageparm.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="pageparm.total"
    ></el-pagination>
    <!-- 添加字典类型 -->
    <el-dialog
    title="添加字典类型"
    :append-to-body='true'
    :visible.sync="roleVisible"
    >
      <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="120px"
      >
        <el-form-item label="字典类型名称" prop="typeName">
          <el-input v-model="ruleForm.typeName" placeholder="请输入字典类型名称"></el-input>
        </el-form-item>
        <el-form-item label="字典类型编码" prop="typeCode">
          <el-input v-model="ruleForm.typeCode" placeholder="请输入字典类型编码"></el-input>
        </el-form-item>
        <el-form-item label="字典类型描述" prop="typeDesc">
          <el-input v-model="ruleForm.typeDesc" placeholder="请输入字典类型描述"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit_role()">提交</el-button>
          <el-button @click="resetChecked()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <el-button
    type="primary"
    icon="el-icon-download"
    @click="doExport"
    >下载PDF</el-button> -->
  </div>
</template>

<script>
  import Pagination from '../Pagination.vue'
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        listData:[],//字典类型列表
        //分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        roleVisible:false,//显影表单
        ruleForm:{
          typeName:'',
          typeCode:'',
          typeDesc:''
        },
        //表单验证
        rules:{
          typeName:[
            {required:true,message:'请输入字典类型名称',trigger:'blur'}
          ],
          typeCode:[
            {required:true,message:'请输入字典类型编码',trigger:'blur'}
          ],
          typeDesc:[
            {required:true,message:'请输入字典类型描述',trigger:'blur'}
          ]
        }
      }
    },
    components:{
      Pagination
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      that.pageparm.currentPage=1
      that.pageparm.pageSize=10
      //字典类型列表
      that.dict_list()
    },
    mounted() {

    },
    methods:{
      //字典类型分页
      pageparm_size_change(val){
        this.pageparm.pageSize=val
        //字典类型列表
        this.dict_list()
      },
      pageparm_current_change(val){
        this.pageparm.currentPage=val
        //字典类型列表
        this.dict_list()
      },
      //字典类型列表
      dict_list(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/dict/type/list?page='+that.pageparm.currentPage+'&limit='+that.pageparm.pageSize
        }).then(data=>{
          if(data.data.success==true){
            //获取当前用户按钮权限
            that.$axios({
              method:'get',
              url:that.publicAjax.extra_path+'/admin/user/permission'
            }).then(data=>{
              if(data.data.success==true){
                that.btn_permission=data.data.data
              }else{
                that.$message.error(data.data.message)
              }
            })
            data.data.data.list.forEach(elem=>{
              that.$set(elem,'name_show',true)
              that.$set(elem,'code_show',true)
              that.$set(elem,'des_show',true)
              // elem.name_show=true
              // elem.code_show=true
              // elem.des_show=true
            })
            that.listData=data.data.data.list
            that.pageparm.total=data.data.data.total
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //添加字典类型前置
      addRow(){
        let that=this
        that.roleVisible=true
      },
      //添加字典类型
      submit_role(){
        let that=this
        that.$refs['ruleForm'].validate((valid)=>{
          if(valid){
            that.$axios({
              method:'post',
              url:that.publicAjax.extra_path+'/admin/dict/type',
              data:that.ruleForm,
              headers:{
                "client": "web", //电脑浏览器:web,手机:mobile
                "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
              if(data.data.success==true){
                that.$message.success(data.data.message)
                that.roleVisible=false
                //字典类型列表
                that.dict_list()
              }else{
                that.$message.error(data.data.message)
              }
            })
          }else{
            return false
          }
        })
      },
      //重置表单
      resetChecked(){
        this.$refs['ruleForm'].resetFields()
      },
      //删除字典类型
      deleteRow(row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/admin/dict/type/'+row.id
          }).then(data=>{
            if(data.data.success==true){
              //字典类型列表
              that.dict_list()
              that.$message.success(data.data.message)
            }else{
              that.$message.error(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //单元格获得焦点
      name_span(row){
        row.name_show=false
        row.old_typeName=row.typeName
      },
      code_span(row){
        row.code_show=false
        row.old_typeCode=row.typeCode
      },
      des_span(row){
        row.des_show=false
        row.old_typeDesc=row.typeDesc
      },
      //单元格失去焦点
      name_input(row){
        let that=this
        if(row.typeName!=''){
          row.name_show=true
          if(row.typeName!=row.old_typeName){
            //修改字典类型名称、编码、描述
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/dict/type/'+row.id,
              data:{
                typeCode:row.typeCode,
                typeName:row.typeName,
                typeDesc:row.typeDesc
              },
              headers:{
                "client": "web", //电脑浏览器:web,手机:mobile
                "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
              if(data.data.success==true){
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }
        }else{
          that.$message.error('字典类型名称不能为空')
        }
      },
      code_input(row){
        let that=this
        if(row.typeCode!=''){
          row.code_show=true
          if(row.typeCode!=row.old_typeCode){
            //修改字典类型名称、编码、描述
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/dict/type/'+row.id,
              data:{
                typeCode:row.typeCode,
                typeName:row.typeName,
                typeDesc:row.typeDesc
              },
              headers:{
                "client": "web", //电脑浏览器:web,手机:mobile
                "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
              if(data.data.success==true){
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }
        }else{
          that.$message.error('字典类型编码不能为空')
        }
      },
      des_input(row){
        let that=this
        if(row.typeDesc!=''){
          row.des_show=true
          if(row.typeDesc!=row.old_typeDesc){
            //修改字典类型名称、编码、描述
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/dict/type/'+row.id,
              data:{
                typeCode:row.typeCode,
                typeName:row.typeName,
                typeDesc:row.typeDesc
              },
              headers:{
                "client": "web", //电脑浏览器:web,手机:mobile
                "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                "Authorization": "Bearer " + localStorage.getItem('jwtToken'),
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
              if(data.data.success==true){
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }
        }else{
          that.$message.error('字典类型描述不能为空')
        }
      },
      //导出PDF
      // doExport(){
      //   let that=this
      //   let ex_href='/v1.2/AUTH_EOS-SCP-CORE/print-file/YJDFXTTEST_4409dd93e85c48c48e89e70ad2e1259f_SF1690014030290_fm_210_standard_YJDFXTTEST_1_1_1.pdf'
      //   that.$axios({
      //     url:that.publicAjax.extra_path+ex_href,
      //     method:'get',
      //     responseType:'blob',
      //     headers:{
      //       'X-Auth-token':'AUTH_tkv12_f146d1855480549d262b5c46ab0ab597207bd99206fbe23b524336bf014ef5140feb297041dd0a61c3b1c69e462cc061d55f0de15d461b5061b66be3d7ea3c3e83e3f8cff0b9e516a7d899d5f2ea02b78350e1d055342e792c8f5533b1efd6195a6a29a67a68721e17061688261cbe952f88571d0e1eeda87821f6efc96d213b3b90ae2aa3a7dc0e15f185b806e816164d15229bdf0c598c2d02a9a8a704c293b1b9debc86a717d742b2f8d4ddc4316f96964b7345df1803abeca77b7f2f90d3'
      //     }
      //   }).then(data=>{
      //     let pdfUrl=window.URL.createObjectURL(new Blob([data.data], {type:"application/pdf"}))
      //     let link=document.createElement('a')
      //     link.href=pdfUrl
      //     link.style.display='none'
      //     link.setAttribute('download','测试_7.pdf')
      //     document.body.appendChild(link)
      //     link.click()
      //     URL.revokeObjectURL(link.href)
      //     document.body.removeChild(link)
      //   })
      // }
    }
  }
</script>

<style scoped="scoped">
  .el_div{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 20px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .operate{
    margin-bottom: 2px;
    cursor: pointer;
  }
  .active{
    border: 1px solid #409eff !important;
    border-radius: 4px;
  }
  .off_active{
    border: 1px solid transparent !important;
  }
</style>
<style>
  #emptransfer .el-input__inner{
    border: 1px solid transparent !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/dict_type.vue